import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import Select from "react-dropdown-select";
import { useTranslation } from "react-i18next";
import $ from "jquery";

import BuddibleSocket, { MsgIDList } from "../../../../lib/BuddibleSocket";
import CodeList from "../../../../lib/CodeList";
import Utilities from "../../../../lib/Utilities";

import CommonNav from "../../../CommonNav2";
import BannerMarketing from "../../BannerMarketing2";
import ScheduleLCLTable from "./ScheduleLCLTable";
import CitySelect from "../../CitySelect";
import Footer from "../../../Footer";

import Loading from "../../../../lib/Loading";
import LogoSvg from "../../../../assets/LogoSvg";
import UploadImageToS3WithPhp from "../../../../lib/UploadImageToS3WithPhp";
import { BCompSelectOption } from "../../../../lib/CommonUI";

window.jQuery = $;
window.$ = $;
global.jQuery = $;

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "ScheduleLCL";

let loginInfo = null;
let schedule_list = [];

let rowsPerPage = 20;
let page = 0;
let pageSize = 0;
let totalCount = 0;
let totalPageCount = 0;
let filters = {
  sm_FCL_LCL: "LCL",
  sm_DOC_CLOSE: util.todayDate("YYYY-MM-DD"),
  sm_POL_CODE: "",
  sm_POD_CODE: "",
  sm_PROMO_YN: "",
  ORIGIN: "",
  DEST: "",
  SEARCH_COMP: "",
};

let modal_data = null;
let isSearch = false;
let isShareAccess = false;
let isCostModalOpen = false;
let isBookingModalOpen = false;
let consolidatorList = [];
let isPromoState = null;
let isRequesting = false;
const shUUID = util.makeUUIDv4();

export default function ScheduleLCL() {
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isScheduleLoad, setIsScheduleLoad] = useState(true);
  const [isReserveModalOpen, setIsReserveModalOpen] = useState(false);
  const [selectedComp, setSelectedComp] = useState([]);
  const [isShowPOLSelect, setIsShowPOLSelect] = useState(false);
  const [isShowPODSelect, setIsShowPODSelect] = useState(false);
  const [searchHeight, setSearchHeight] = useState(540);

  const params = useParams();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const $polRef = useRef();
  const $podRef = useRef();
  const $consolidatorSelectRef = useRef();
  const $promo_check = useRef();

  useEffect(() => {
    if (location) {
      if (location.state && location.state.hasOwnProperty("type")) {
        if (location.state.type === "promo") {
          filters = {
            ...filters,
            sm_PROMO_YN: "Y",
          };
          isPromoState = { type: "promo" };
          $promo_check.current.checked = true;
        }
        if (location.state.hasOwnProperty("sm_POL_CODE")) {
          filters = {
            ...filters,
            sm_POL_CODE: location.state.sm_POL_CODE,
            sm_POD_CODE: location.state.sm_POD_CODE,
            ORIGIN: location.state.ORIGIN,
            DEST: location.state.DEST,
          };
          isSearch = true;
        }
      }
    }

    const userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData) {
      if (userData.ret) {
        loginInfo = userData["returnData"][0];
      }
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (n) {
          if (n.ret) {
            loginInfo = n["returnData"][0];
          }
        }
      }
    );

    let id = "";
    if (params && params.hasOwnProperty("id")) {
      id = params.id;
      isSearch = true;
      isShareAccess = true;
    }

    i18n.changeLanguage(i18n.language, (err) => {});
    resizeLayout();
    SELECT_CONSOLIDATOR_LIST();
    SELECT_LCL_SCHEDULE_LIST(id);
    window.addEventListener("resize", resizeLayout);
    return () => {
      rowsPerPage = 10;
      page = 0;
      pageSize = 0;
      totalCount = 0;
      totalPageCount = 0;
      filters = {
        sm_FCL_LCL: "LCL",
        sm_DOC_CLOSE: util.todayDate("YYYY-MM-DD"),
        sm_POL_CODE: "",
        sm_POD_CODE: "",
        sm_PROMO_YN: "",
        ORIGIN: "",
        DEST: "",
        SEARCH_COMP: "",
      };
      schedule_list = [];

      modal_data = null;
      isSearch = false;
      isShareAccess = false;

      window.removeEventListener("resize", resizeLayout);
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );
      socket.removeLocalEventListener(
        MsgIDList.EVENT_INIT_CODE_COUNTRY_FULL_NAME,
        _mClassName
      );
    };
  }, []);

  function resizeLayout() {
    if (window.innerWidth < 992) {
      setSearchHeight(800);
    } else {
      setSearchHeight(540);
    }
  }

  //콘솔사 데이터 요청
  function SELECT_CONSOLIDATOR_LIST() {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/b_logo/JS_b_logo_select.php",
      msgID: msgID,
      data: [],
      USE_YN: "Y",
      blSchDisplay: "Y",
      blCompType: "B",
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          consolidatorList = [...newData["returnData"]];
          setIsNeedUpdate(!isNeedUpdate);
        }
      }
    });
  }

  //로지스몰 스케줄 정보 받아오기
  function SELECT_LCL_SCHEDULE_LIST(id) {
    setIsScheduleLoad(true);
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_select.php",
      msgID: msgID,
      data: {},
      take: rowsPerPage,
      skip: page * rowsPerPage,
      page: page + 1,
      pageSize: 5,
      sort: [
        {
          field: "sm_DOC_CLOSE",
          dir: "asc",
        },
      ],
      sp_DISPLAY: 0,
      ...filters,
    };
    if (id) {
      let log_data = {
        shClick: 0,
        shClickFor: "share",
      };
      log_data.shClick = 0;
      log_data.shClickFor = "share";
      socketMsg.sm_UID = id;
      sendUserUsedData(log_data);
    }

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          schedule_list =
            newData["returnData"].length > 0
              ? [...schedule_list, ...newData["returnData"]]
              : [];
          pageSize = newData.pageSize;
          totalCount = parseInt(newData.pageSize, 10);
          totalPageCount =
            newData["returnData"].length > 0
              ? parseInt(
                  parseInt(newData.pageSize, rowsPerPage) / rowsPerPage,
                  rowsPerPage
                ) +
                (parseInt(newData.pageSize, rowsPerPage) % rowsPerPage > 0
                  ? 1
                  : 0)
              : 0;
          isRequesting = false;
          setIsScheduleLoad(false);
        }
      }
    });
  }

  //예약하기 모달 토글
  function handleBookingModal(value) {
    isBookingModalOpen = value;
    setIsNeedUpdate(!isNeedUpdate);
  }

  //운임 안내 모달 토글
  function handleCostModal(value) {
    isCostModalOpen = value;
    setIsNeedUpdate(!isNeedUpdate);
  }

  //검색 값 변경
  function changeFilters(data) {
    filters = {
      ...filters,
      ...data,
    };
    page = 0;
    if (data.hasOwnProperty("sm_PROMO_YN")) {
      isSearch = true;
      schedule_list = [];
      setIsScheduleLoad(true);
      SELECT_LCL_SCHEDULE_LIST();
    }
  }

  //스케줄 검색
  function clickSearch() {
    page = 0;
    isSearch = true;
    schedule_list = [];
    SELECT_LCL_SCHEDULE_LIST();
  }

  //검색필터 초기화
  function handleResetFilters() {
    $polRef.current.value = "";
    $podRef.current.value = "";
    $promo_check.current.checked = false;
    filters = {
      sm_FCL_LCL: "LCL",
      sm_DOC_CLOSE: util.todayDate("YYYY-MM-DD"),
      sm_POL_CODE: "",
      sm_POD_CODE: "",
      sm_PROMO_YN: "",
      ORIGIN: "",
      DEST: "",
      SEARCH_COMP: "",
    };
    page = 0;
    isSearch = false;
    isPromoState = null;
    setSelectedComp([]);
    schedule_list = [];
    if (params && params.hasOwnProperty("id")) {
      const replaceUrl = `${window.location.origin}/ScheduleLCL`;
      window.location.replace(replaceUrl);
    }
    SELECT_LCL_SCHEDULE_LIST();
  }

  // LCL운임 정보 요청
  function SELECT_COST_LIST_OF_LCL(data, callback) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_price_lcl_select.php",
      msgID: msgID,
      data: {},
      sm_POL_CODE: data.sm_POL_CODE,
      sm_POD_CODE: data.sm_POD_CODE,
    };
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          callback && callback(newData);
        }
      }
    });
  }

  //운임안내 모달 오픈
  function openCostModal(data) {
    if (!loginInfo) {
      codeList.Modal.current.alert(t("schedule.msg.onlyForwarder"));
      return false;
    }

    if (!util.checkCompGB(loginInfo)) {
      codeList.Modal.current.alert(t("schedule.msg.onlyForwarder"));
      return;
    }

    if (!(data instanceof Object) || !data.sm_IDX) {
      codeList.Modal.current.alert(t("schedule.msg.error"));
      return;
    }

    SELECT_COST_LIST_OF_LCL(data, (newData) => {
      let price_list =
        newData["price_list"].length > 0
          ? newData["price_list"]
          : [
              {
                SP_KND: "OCEAN FREIGHT",
                SP_DIV: "R.TON",
                SP_CUR: "",
                SP_PRICE: "-",
              },
              {
                SP_KND: "SURCHARGE",
                SP_DIV: "R.TON",
                SP_CUR: "",
                SP_PRICE: "-",
              },
            ];
      modal_data = {
        ...data,
        price_list: [...price_list, ...newData["price_default_list"]],
      };
      isCostModalOpen = true;
      setIsNeedUpdate(!isNeedUpdate);
    });
  }

  // 예약 모달 오픈
  function openBookingModal() {
    isCostModalOpen = false;
    isBookingModalOpen = true;
    setIsNeedUpdate(!isNeedUpdate);
  }

  //부킹데이터 제출
  function INSERT_REQUEST_BOOKING_DATA(data) {
    isBookingModalOpen = false;
    setIsLoading(true);
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_booking_insert.php",
      msgID: msgID,
      data: {},
      ...data,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          setIsLoading(false);
          setIsReserveModalOpen(true);
        } else {
          codeList.Modal.current.alert(t("schedule.msg.error"));
          setIsLoading(false);
        }
      }
    });
  }

  //사용자 로그 등록
  function scheduleUseLog(type, isClick, data) {
    sendUserUsedData({
      shIDX: data.sm_IDX,
      shType: data.sm_FCL_LCL,
      shDate: "",
      shORIGIN: data.sm_POL_CODE,
      shDEST: data.sm_POD_CODE,
      shClick: isClick,
      shClickFor: type,
    });
    isCostModalOpen = false;
    isBookingModalOpen = true;
  }

  function sendUserUsedData(data) {
    let log_data = {
      shUUID: shUUID,
      shIDX: "", //스케줄 No
      shDate: filters.sm_DOC_CLOSE, // 검색일자(출발일)
      shType: filters.sm_FCL_LCL, // FCL,LCL,항공
      shORIGIN: filters.sm_POL_CODE, //출발지 POL
      shDEST: filters.sm_POD_CODE, //도착지 POD
      shClick: 0, //클릭여부
      shClickFor: "", //클릭 분류
      shMethod: window.location.href, //발생 URL
      ...data,
    };
    if (loginInfo && loginInfo.hasOwnProperty("user_id")) {
      log_data["shCOMPCD"] = loginInfo.comp_cd;
      log_data["shUSERID"] = loginInfo.user_id;
    }

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule/JS_schedule_select_log_insert.php",
      msgID: msgID,
      data: {},
      ...log_data,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {});
  }

  function insertUserLog(item, type, isClick) {
    sendUserUsedData({
      shIDX: item.sm_IDX,
      shType: item.sm_FCL_LCL,
      shDate: "",
      shORIGIN: item.sm_POL_CODE,
      shDEST: item.sm_POD_CODE,
      shClick: isClick,
      shClickFor: type,
    });
  }

  //페이지 이동
  function handleChangePage(val) {
    if (schedule_list.length === Number(pageSize) || isRequesting) return;

    isRequesting = true;
    page = val;
    const currentScrollTop = document.documentElement.scrollTop;
    window.scrollTo(0, currentScrollTop);
    SELECT_LCL_SCHEDULE_LIST();
  }

  function requestEnquiry(item) {
    codeList.Modal.current.confirm(
      `[${item.sm_ORIGIN}-${item.sm_DEST}]` + t("schedule.msg.contactSchedule"),
      (ret) => {
        if (ret) {
          if (!loginInfo) {
            codeList.Modal.current.alert(t("schedule.msg.requiresLogin"));
            return;
          }
          localStorage.setItem("enquiryManager", "Z0001|hskim@gbts.co.kr");
          window.open("/LogiTalk", "LogiTalk", "_blank");
        }
      }
    );
  }

  async function copyScheduleURL(item) {
    try {
      const schedule_url = `${window.location.origin}/ScheduleLCL/${item.sm_UID}`;
      await navigator.clipboard.writeText(schedule_url);
      codeList.Modal.current.alert(t("schedule.msg.copyLink"));
    } catch (e) {
      codeList.Modal.current.alert(t("schedule.msg.error"));
    }
  }

  return (
    <>
      {isLoading && <Loading />}

      {isReserveModalOpen && (
        //예약완료 안내 모달(예약관리 바로가기 기능)
        <ReserveSuccessModal setIsReserveModalOpen={setIsReserveModalOpen} />
      )}
      {isBookingModalOpen && modal_data !== null && (
        //예약요청 모달
        <BookingModal
          loginInfo={loginInfo}
          handleBookingModal={handleBookingModal}
          INSERT_REQUEST_BOOKING_DATA={INSERT_REQUEST_BOOKING_DATA}
        />
      )}
      {isCostModalOpen && modal_data !== null && (
        //운임안내 모달
        <LCLCostModal
          loginInfo={loginInfo}
          handleCostModal={handleCostModal}
          requestEnquiry={requestEnquiry}
          scheduleUseLog={scheduleUseLog}
          openBookingModal={openBookingModal}
          copyScheduleURL={copyScheduleURL}
          insertUserLog={insertUserLog}
        />
      )}

      <CommonNav />
      <main className="mh-90vh bg-schedule">
        <div className="position-relative" style={{ height: searchHeight }}>
          <img
            src={
              "https://gbts-invoice.s3.ap-northeast-2.amazonaws.com/talk/chatRoom/Z0001/amber.jung@buddible.com/20250813090933_container.jpg"
            }
            alt="bg"
            className="w-100 position-absolute"
            style={{ top: 0, left: 0, height: searchHeight }}
          />
          <div
            className="w-100 h-100 position-absolute d-flex flex-column justify-content-center align-items-center"
            style={{
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0.2), rgba(19, 22, 56,0.4))",
            }}
          />

          <div
            className="position-absolute w-100 h-100  d-flex flex-column justify-content-center align-items-center"
            style={{ zIndex: 2 }}
          >
            <div className="container mb-3 ">
              <div className="px-3">
                <p className="h4 font-weight-bold d-flex flex-row align-items-end flex-wrap position-relative">
                  <LogoSvg width="200px" color="#fff" point="#0097b7" />
                </p>
                <p className="h4 text-white font-weight-bold">
                  {t("schedule.title")}
                </p>
                <p className="h5 text-white mb-0">
                  {t("schedule.description")}
                </p>
              </div>
            </div>
            <div className="container">
              <div
                className="rounded shadow"
                style={{
                  background: "rgba(255,255,255,0.3)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                  color: "#fff",
                }}
              >
                <div
                  className="row m-0 p-0 text-center text-white"
                  style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.3)" }}
                >
                  <Link
                    to={"/ScheduleLCL"}
                    className="col-4 m-0 p-0 py-2 bg-freiscop text-white text-decoration-none rounded-top-left font-weight-bold"
                    state={isPromoState}
                    style={{
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    }}
                  >
                    <span className="font-size-09">
                      <i className="fa-solid fa-cart-flatbed" />
                    </span>{" "}
                    {t("schedule.lcl.title")}
                  </Link>
                  <Link
                    to={"/ScheduleFCL"}
                    className="col-4 m-0 p-0 py-2 text-white text-decoration-none"
                    state={isPromoState}
                    style={{
                      borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                    }}
                  >
                    {t("schedule.fcl.title")}
                  </Link>
                  <Link
                    to={"/ScheduleAIR"}
                    className="col-4 m-0 p-0 py-2 text-white text-decoration-none rounded-top-right"
                    state={isPromoState}
                  >
                    {t("schedule.air.title")}
                  </Link>
                </div>
                <div className="row m-0 p-0 rounded-bottom-left rounded-bottom-right">
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.docClose")}
                    </p>
                    <input
                      type="date"
                      className="w-100 border-top-0 border-left-0 border-right-0 border-bottom py-1 bg-transparent text-white"
                      min={util.todayDate("YYYY-MM-DD")}
                      defaultValue={filters.sm_DOC_CLOSE}
                      onChange={(e) => {
                        changeFilters({ sm_DOC_CLOSE: e.target.value });
                      }}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.departure")}
                    </p>
                    <div
                      className="position-relative"
                      style={{ paddingTop: 2 }}
                    >
                      <input
                        type="text"
                        className="w-100 border-top-0 border-left-0 border-right-0 border-bottom py-1 bg-transparent text-white"
                        ref={$polRef}
                        readOnly={true}
                        onClick={() => setIsShowPOLSelect(true)}
                      />
                      <span
                        className="position-absolute cursor_pointer text-danger h6 mb-0"
                        style={{ right: 6 }}
                        onClick={() => {
                          const data = {
                            ORIGIN: "",
                            sm_POL_CODE: "",
                          };
                          $polRef.current.value = "";
                          changeFilters(data);
                          setIsShowPOLSelect(false);
                        }}
                      >
                        &times;
                      </span>
                    </div>

                    <div className={isShowPOLSelect ? "" : "d-none"}>
                      <CitySelect
                        isShow={isShowPOLSelect}
                        setIsShow={setIsShowPOLSelect}
                        callback={(res) => {
                          const data = {
                            ORIGIN: res["CityName"],
                            sm_POL_CODE: res["CustomCode"],
                          };
                          $polRef.current.value = `${res["CityName"]}(${res["CityName_EN"]})`;
                          changeFilters(data);
                          setIsShowPOLSelect(false);
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.arrival")}
                    </p>

                    <div
                      className="position-relative"
                      style={{ paddingTop: 2 }}
                    >
                      <input
                        type="text"
                        className="w-100 border-top-0 border-left-0 border-right-0 border-bottom py-1 bg-transparent text-white"
                        ref={$podRef}
                        readOnly={true}
                        onClick={() => setIsShowPODSelect(true)}
                      />
                      <span
                        className="position-absolute cursor_pointer text-danger h6 mb-0"
                        style={{ right: 6 }}
                        onClick={() => {
                          const data = {
                            DEST: "",
                            sm_POD_CODE: "",
                          };
                          $podRef.current.value = "";
                          changeFilters(data);
                          setIsShowPODSelect(false);
                        }}
                      >
                        &times;
                      </span>
                    </div>

                    <div className={isShowPODSelect ? "" : "d-none"}>
                      <CitySelect
                        isShow={isShowPODSelect}
                        setIsShow={setIsShowPODSelect}
                        callback={(res) => {
                          const data = {
                            DEST: res["CityName"],
                            sm_POD_CODE: res["CustomCode"],
                          };
                          $podRef.current.value = `${res["CityName"]}(${res["CityName_EN"]})`;
                          changeFilters(data);
                          setIsShowPODSelect(false);
                        }}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <p className="font-size-09 font-weight-bold">
                      {t("schedule.consolidator")}
                    </p>
                    <Select
                      ref={$consolidatorSelectRef}
                      placeholder={`-${t("schedule.consolidator")}-`}
                      className="w-100 p-0 m-0 border-top-0 border-left-0 border-right-0 border-bottom"
                      dropdownClassName="text-dark"
                      values={selectedComp}
                      options={consolidatorList}
                      onChange={(value) => {
                        if (value.length < 1) {
                          changeFilters({ SEARCH_COMP: "" });
                          return;
                        }

                        setSelectedComp(value);

                        let compKeys = [];
                        for (let i = 0; i < value.length; i++) {
                          let comp = value[i];
                          compKeys.push(comp.blFWDNO);
                        }

                        compKeys = compKeys.join("|");
                        changeFilters({ SEARCH_COMP: compKeys });
                      }}
                      contentRenderer={({ props, state, methods }) => {
                        let str = "";
                        if (state.values.length > 0) {
                          str = `+ ${state.values.length}`;
                        } else {
                          str = props.placeholder;
                        }
                        return <div>{str}</div>;
                      }}
                      onClearAll={() => {
                        setSelectedComp([]);
                      }}
                      {...BCompSelectOption}
                    />
                  </div>
                  <div className="col-12 col-lg-4 m-0 p-2 px-lg-3">
                    <label className="container_check m-0 mb-2 mb-lg-0 mr-lg-3 p-0">
                      <input
                        type="checkbox"
                        className="position-static"
                        defaultChecked={filters.sm_PROMO_YN === "Y"}
                        ref={$promo_check}
                        onChange={(e) => {
                          isPromoState = e.target.checked
                            ? { type: "promo" }
                            : null;

                          changeFilters({
                            sm_PROMO_YN: e.target.checked ? "Y" : "",
                          });
                        }}
                      />
                      <span className="checkmark" />
                      <span className="ml-3">{t("schedule.promotion")}</span>
                    </label>
                  </div>
                  {selectedComp.length > 0 && (
                    <div className="col-lg-12 p-0 m-0">
                      <div
                        className="d-flex flex-row flex-wrap mx-2 mb-3 mb-lg-0 rounded text-dark"
                        style={{
                          background: "rgba(255,255,255, 0.4)",
                          backdropFilter: "blur(10px)",
                          WebkitBackdropFilter: "blur(10px)",
                        }}
                      >
                        {selectedComp.map((item) => {
                          const logo = item.blLOGO
                            ? item.blLOGO.split("?")[0]
                            : "";
                          return (
                            <div key={item.blIDX}>
                              <div
                                role="option"
                                aria-selected="false"
                                tabIndex="-1"
                                className="react-dropdown-select-item css-148o527-ItemComponent evc32pp0 cursor_pointer cursor_pointer_bg_light pr-2 px-lg-2 py-1 d-flex flex-row align-items-center rounded"
                                onClick={() => {
                                  let _selectedComp = [...selectedComp];
                                  let delIDX = _selectedComp.findIndex(
                                    (data) => data.blIDX === item.blIDX
                                  );
                                  if (delIDX > -1) {
                                    _selectedComp.splice(delIDX, 1);
                                  }
                                  setSelectedComp(_selectedComp);
                                }}
                              >
                                <span className="h6 m-0 mr-2 text-danger">
                                  &times;
                                </span>
                                {logo.trim() !== "" && (
                                  <div
                                    className="d-inline-block mr-2"
                                    style={{
                                      width: "1rem",
                                      height: "1rem",
                                      background: `url(${logo}) 50% 50% / contain no-repeat`,
                                    }}
                                  />
                                )}
                                <p className="d-inline-block">
                                  <b>{item.blCompNM_KO}</b>{" "}
                                  <span className="font-size-08">
                                    [{item.blCompNM}]
                                  </span>
                                </p>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                  <div className="col-12 m-0 p-2 px-lg-3 d-flex flex-row justify-content-end">
                    <button
                      className="btn_1 px-4 mr-2 rounded-sm"
                      onClick={clickSearch}
                    >
                      {t("schedule.search")}
                    </button>
                    <button
                      className="btn_1 bg-secondary border-secondary rounded-sm"
                      onClick={handleResetFilters}
                    >
                      {t("schedule.reset")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container margin_30 mt-0">
          <div className="row">
            <div className="col-12 my-2">
              <p className="h6 font-weight-bold mb-0 mt-1 px-2">
                {t("schedule.total")}{" "}
                <span className="text-info font-weight-bold">
                  {util.addCommas(pageSize)}
                  {t("schedule.items")}
                </span>
                {t("schedule.searched")}
                <br className="d-sm-none" />
                <span style={{ fontSize: "0.8em" }}>
                  ( <i className="fa-solid fa-share-nodes mr-1 text-primary" />
                  {t("schedule.msg.shareSchedule")} )
                </span>
              </p>
            </div>
            <div className="col-12 m-0 mb-2 p-0">
              <BannerMarketing />
            </div>
            <div className="col-12">
              {schedule_list.length > 0 && (
                <ScheduleLCLTable
                  page={page}
                  totalPageCount={totalPageCount}
                  consolidatorList={consolidatorList}
                  schedule_list={schedule_list}
                  loginInfo={loginInfo}
                  openCostModal={openCostModal}
                  handleChangePage={handleChangePage}
                  copyScheduleURL={copyScheduleURL}
                  insertUserLog={insertUserLog}
                />
              )}
              {schedule_list.length === 0 && !isScheduleLoad && (
                <div className="bg-white rounded p-5 h6 text-center font-weight-bold text-secondary">
                  {t("schedule.msg.noSchedule")}
                </div>
              )}
              {isScheduleLoad && (
                <div className="rounded p-5 h6 text-center">
                  <div className="d-flex justify-content-center">
                    <div
                      className="spinner-grow text-secondary"
                      role="status"
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}

//예약요청 완료 모달
const ReserveSuccessModal = ({ setIsReserveModalOpen }) => {
  const { t } = useTranslation();
  return (
    <div className="modal_background">
      <div className="modal_body bg-white rounded" style={{ minWidth: 320 }}>
        <div className="p-3 border-bottom d-flex flex-row justify-content-between align-items-center">
          <p className="h6 mr-3 p-0 m-0">
            {t("schedule.lcl.successBookingModal.info")}
          </p>
          <div
            className="btn btn-sm btn-danger"
            onClick={() => setIsReserveModalOpen(false)}
          >
            <i className="fa-solid fa-xmark" />
          </div>
        </div>
        <div className="p-3">{t("schedule.lcl.successBookingModal.title")}</div>
        <div className="d-flex flex-row justify-content-end border-top p-3">
          <Link
            to="/ERP/ScheduleBookingManage"
            className="btn btn-sm btn-outline-secondary mr-2"
          >
            {t("schedule.lcl.successBookingModal.moveReserveManage")}
          </Link>
          <button
            className="btn btn-sm btn-primary"
            onClick={() => setIsReserveModalOpen(false)}
          >
            {t("schedule.lcl.successBookingModal.ok")}
          </button>
        </div>
      </div>
    </div>
  );
};

const LCLCostModal = (props) => {
  const {
    handleCostModal,
    requestEnquiry,
    scheduleUseLog,
    openBookingModal,
    copyScheduleURL,
    insertUserLog,
  } = props;
  const { t } = useTranslation();
  return (
    <>
      <div className="modal_background">
        <div
          className="modal_body bg-white shadow rounded"
          style={{ minWidth: 320 }}
        >
          <div className="d-flex flex-row justify-content-center border-bottom">
            <div
              className="py-2 px-3 d-flex flex-row justify-content-between align-items-center w-100"
              style={{ maxWidth: 1200 }}
            >
              <p className="h6 font-weight-bold mr-3 p-0 m-0">
                {t("schedule.lcl.costModal.title")}
              </p>
              <div
                className="h5 mb-0 text-danger cursor_pointer font-weight-bold"
                onClick={() => handleCostModal(false)}
              >
                &times;
              </div>
            </div>
          </div>
          <div
            className="overflow-auto p-3 px-3"
            style={{ maxHeight: "calc(100vh - 200px)" }}
          >
            <div className="mb-3">
              <div className="row m-0 p-0 border rounded overflow-hidden">
                <div className="col-4 col-xl-2 m-0 p-0 border-right d-flex flex-column">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    {t("schedule.scheduleNo")}
                  </div>
                  <div className="p-2 text-center d-flex flex-column justify-content-center flex-fill">
                    <span
                      className="cursor_pointer"
                      onClick={() => {
                        copyScheduleURL(modal_data);
                        insertUserLog(modal_data, "share", 1);
                      }}
                    >
                      <i className="fa-solid fa-share-nodes mr-1 text-primary" />
                      {modal_data.sm_UID}
                    </span>
                  </div>
                </div>
                <div className="col-4 col-xl-2 m-0 p-0 border-right d-flex flex-column">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    {t("schedule.consolidator")}
                  </div>
                  <div
                    className="flex-fill d-flex flex-row justify-content-center align-items-center"
                    style={{ height: 55 }}
                  >
                    {modal_data.COMP_LOGO ? (
                      <div
                        style={{
                          backgroundImage: `url('${
                            modal_data.COMP_LOGO.split("?")[0]
                          }')`,
                          backgroundPosition: "50% 50%",
                          backgroundSize: "contain",
                          backgroundRepeat: "no-repeat",

                          width: "50px",
                          height: "50px",
                        }}
                      />
                    ) : (
                      <LogoSvg width={"60px"} />
                    )}
                  </div>
                </div>
                <div className="col-4 col-xl-2 m-0 p-0 border-right d-flex flex-column">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    FCL/LCL
                  </div>
                  <div className="p-2 text-center d-flex flex-column justify-content-center flex-fill">
                    {modal_data.sm_FCL_LCL}
                  </div>
                </div>
                <div className="col-4 col-xl-2 m-0 p-0 border-right d-flex flex-column">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    VESSEL/VOY
                  </div>

                  <div className="flex-fill p-2 text-center d-flex flex-column justify-content-center">
                    <p className="mb-0">{modal_data.sm_VESSEL}</p>
                    <p className="mb-0">{modal_data.sm_VOY}</p>
                  </div>
                </div>
                <div className="col-4 col-xl-2 m-0 p-0 border-right d-flex flex-column">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    POL
                  </div>
                  <div className="flex-fill p-2 text-center d-flex flex-column justify-content-center">
                    <p className="font-weight-bold">{modal_data.sm_POL_NAME}</p>
                    <p className="text-danger">
                      {modal_data.sm_DEPARTURE_DATE}
                    </p>
                  </div>
                </div>
                <div className="col-4 col-xl-2 m-0 p-0">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    POD
                  </div>
                  <div className="flex-fill p-2 text-center d-flex flex-column justify-content-center">
                    <p className="font-weight-bold">{modal_data.sm_POD_NAME}</p>
                    <p className="text-danger">{modal_data.sm_ARRIVE_DATE}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-2">
              <div className="d-flex flex-row justify-content-between">
                <p className="font-weight-bold mb-1">
                  ※ GENERAL RATE FOR FOWARDER
                </p>
                <p className="font-weight-bold text-right">
                  {t("schedule.lcl.costModal.bookYN")} :{" "}
                  <span className={"text-primary"}>
                    {t("schedule.lcl.costModal.bookY")}
                  </span>
                </p>
              </div>
              <div className="container-fluid m-0 p-0 text-center font-size-09">
                <div className="row m-0 p-0 border bg-light font-weight-bold">
                  <div className="col-5 m-0 p-0 border-right">
                    <p className="py-1 px-2">CATEGORY</p>
                  </div>
                  <div className="col-2 m-0 p-0 border-right">
                    <p className="py-1 px-2">PER</p>
                  </div>
                  <div className="col-5 m-0 p-0">
                    <p className="py-1 px-2">AMOUNT</p>
                  </div>
                </div>
                {modal_data.price_list.map((price, index) => {
                  const key_start = price.SP_KND ? "SP_" : "SPD_";

                  return (
                    <div
                      key={index}
                      className={`row m-0 p-0 border-left border-right border-bottom ${
                        key_start === "SP_" ? "font-weight-bold" : ""
                      }`}
                    >
                      <div className="col-5 m-0 p-0 border-right bg-light">
                        <p className="py-1 px-2">{price[key_start + "KND"]}</p>
                      </div>
                      <div className="col-2 m-0 p-0 border-right">
                        <p className="py-1 px-2">{price[key_start + "DIV"]}</p>
                      </div>
                      <div className="col-5 m-0 p-0">
                        <p className="py-1 px-2 text-right">
                          {price[key_start + "CUR"]}{" "}
                          {util.addCommas(price[key_start + "PRICE"])}
                        </p>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="mt-1">
                <p className="font-weight-bold">
                  ※ {t("schedule.lcl.costModal.msg.timingNotice")}
                </p>
                <p className="text-danger">
                  ※ {t("schedule.lcl.costModal.msg.costNotice")}
                </p>
              </div>
            </div>

            <div className="mb-3">
              <div className="mb-1 d-flex flex-row">
                <span className="d-inline-block pr-2">·</span>
                <p>
                  <span className="font-weight-bold mr-1">
                    {t("schedule.lcl.costModal.bookInquiry")} :
                  </span>{" "}
                  김호승 본부장 (032-751-9870, hskim@bstc.kr)
                </p>
              </div>
              <div className="mb-1 d-flex flex-row">
                <span className="d-inline-block pr-2">·</span>
                <p>
                  <span className="font-weight-bold mr-1">
                    {t("schedule.lcl.costModal.blInquiry")} :
                  </span>{" "}
                  김호승 본부장 (032-751-9870, hskim@bstc.kr)
                </p>
              </div>
              <div className="mb-1 d-flex flex-row">
                <span className="d-inline-block pr-2">·</span>
                <p>
                  <span className="font-weight-bold mr-1">
                    {t("schedule.lcl.costModal.cfsInfo")} :
                  </span>{" "}
                  {modal_data.smName ? (
                    <>
                      <Link
                        to={`/storeMall/${modal_data.sm_CFS}`}
                        target="_blank"
                        className="mr-1 btn btn-sm btn-outline-info font-size-06 p-1"
                      >
                        {t("schedule.lcl.costModal.showDetail")}
                      </Link>{" "}
                      {modal_data.smName}({modal_data.smAddrFull}/
                      {modal_data.smTel})
                    </>
                  ) : (
                    "-"
                  )}
                </p>
              </div>
            </div>
            <div className="d-flex flex-row justify-content-end">
              <div className="d-flex flex-row">
                <button
                  className="mr-2 btn btn-sm btn-outline-info font-size-09"
                  style={{ lineHeight: 1.3 }}
                  onClick={() => requestEnquiry(modal_data)}
                >
                  {t("schedule.lcl.costModal.talkToSales")}
                </button>
                <button
                  className="btn btn-sm btn-info font-size-09"
                  style={{ lineHeight: 1.3 }}
                  onClick={() => {
                    scheduleUseLog("book", 1, modal_data);
                    openBookingModal(modal_data.sm_IDX);
                  }}
                >
                  {t("schedule.lcl.costModal.booking")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

let bookingEmail = [];
// 예약 모달
const BookingModal = (props) => {
  const { loginInfo, handleBookingModal, INSERT_REQUEST_BOOKING_DATA } = props;
  const [uploadFile, setUploadFile] = useState([]);
  const [emailCount, setEmailCount] = useState(1);
  const { t } = useTranslation();
  let payment = "A";
  const $controller = {
    p_name: useRef(),
    p_comp_nm: useRef(),
    p_user: useRef(),
    p_cnt: useRef(),
    p_weight: useRef(),
    p_quantities: useRef(),
    p_memo: useRef(),
  };

  bookingEmail[0] = loginInfo.user_id;

  //예약 첨부파일 업로드
  function handleUploadFile(value) {
    if (!value.ret) {
      codeList.Modal.current.alert(
        t("schedule.lcl.bookingModal.msg.errorUploadFile")
      );
      return;
    }
    let dataList = [...uploadFile];
    //파일명?파일주소
    dataList.push(`${value.realFileName}?${value.fileName}`);
    setUploadFile(dataList);
  }

  //첨부된 파일 삭제
  function handleDeleteUploadFile(index) {
    let dataList = [];
    for (let i = 0; i < uploadFile.length; i++) {
      if (i !== index) {
        dataList.push(uploadFile[i]);
      }
    }
    setUploadFile(dataList);
  }

  //회신 이메일 개수 증감
  function emailCountUp() {
    setEmailCount((count) => ++count);
  }

  function emailCountDown(index) {
    if (emailCount > 1) {
      let dataList = [];
      for (let i = 0; i < bookingEmail.length; i++) {
        if (i !== index) {
          dataList.push(bookingEmail[i]);
        }
      }

      bookingEmail = dataList;
      setEmailCount((count) => --count);
    }
  }

  //제출
  function submit() {
    for (let key in $controller) {
      if (key === "p_comp_nm" && $controller[key].current.value === "") {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.enterShipperName")
        );
        return;
      }
      if (key === "p_user" && $controller[key].current.value === "") {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.enterBLNumber")
        );
        return;
      }
      if (key === "p_name" && $controller[key].current.value === "") {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.enterItemName")
        );
        return;
      }
      if (key === "p_cnt" && $controller[key].current.value === "") {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.enterBookingCount")
        );
        return;
      }
      if (key === "p_weight" && $controller[key].current.value === "") {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.enterWeight")
        );
        return;
      }
      if (key === "p_quantities" && $controller[key].current.value === "") {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.enterQuantityUnit")
        );
        return;
      }
    }

    bookingEmail[0] = loginInfo.user_id;
    for (let i = 0; i < bookingEmail.length; i++) {
      if (!util.validationEmail(bookingEmail[i])) {
        codeList.Modal.current.alert(
          t("schedule.lcl.bookingModal.msg.invalidEmail")
        );
        return;
      }
    }

    let emails = bookingEmail.join("|");
    let files = "";
    if (uploadFile.length > 0) {
      files = uploadFile.join("|");
    }

    let data = {
      sm_UID: modal_data.sm_UID,

      sb_IDX_MAIN: modal_data.sm_IDX,
      sb_PRODUCT_NAME: $controller.p_name.current.value,
      sb_COMP_NM: $controller.p_comp_nm.current.value,
      sb_USER_NM: $controller.p_user.current.value,
      sb_CNT: $controller.p_cnt.current.value,
      sb_WEIGHT: $controller.p_weight.current.value,
      sb_QUANTITIES: $controller.p_quantities.current.value,
      sb_EMAIL: emails,
      sb_MEMO: $controller.p_memo.current.value,
      sb_FILE: files,
      sb_COMP_CD: loginInfo.comp_cd,
      sb_USER_ID: loginInfo.user_id,
      sb_PAYMENT: payment,
      sb_COMP_NAME: loginInfo.comp_nm,
      sb_USER_NAME: loginInfo.user_nm,

      sb_CFS: modal_data.sm_CFS,
      sb_FWD_NO: modal_data.sm_FWD_NO,
      sb_FWD_NM: modal_data.sm_FWD_NM,
      sb_PROVIDER_CODE: modal_data.sm_PROVIDER_CODE,
      sb_PROVIDER_ID: modal_data.sm_PROVIDER_ID,
      sb_FCL_LCL: modal_data.sm_FCL_LCL,
      sb_VESSEL: modal_data.sm_VESSEL,
      sb_VOY: modal_data.sm_VOY,
      sb_DOC_CLOSE: modal_data.sm_DOC_CLOSE,
      sb_DOC_CLOSE_TIME: modal_data.sm_DOC_CLOSE_TIME,
      sb_CARGO_CLOSE: modal_data.sm_CARGO_CLOSE,
      sb_CARGO_CLOSE_TIME: modal_data.sm_CARGO_CLOSE_TIME,
      sb_ORIGIN: modal_data.sm_POL_CODE, //sm_ORIGIN 의 경우 select 쿼리 실행시 "지역명(지역영문명)" 으로 대체되어 들어오기 때문에 POL_CODE 사용
      sb_DEST: modal_data.sm_POD_CODE, //sm_DEST 의 경우 select 쿼리 실행시 "지역명(지역영문명)" 으로 대체되어 들어오기 때문에 POD_CODE 사용 ※ schedule/JS_schedule_select.php 참고
      sb_DEPARTURE_DATE: modal_data.sm_DEPARTURE_DATE,
      sb_ARRIVE_DATE: modal_data.sm_ARRIVE_DATE,
      sb_POL_CODE: modal_data.sm_POL_CODE,
      sb_POD_CODE: modal_data.sm_POD_CODE,
      sb_LINE: modal_data.sm_LINE,
      sb_REGION: modal_data.sm_REGION,
      sb_REMARK: modal_data.sm_REMARK,

      sb_POL_NAME: modal_data.sm_ORIGIN,
      sb_POD_NAME: modal_data.sm_DEST,
    };

    bookingEmail = [];
    INSERT_REQUEST_BOOKING_DATA(data);
  }

  //회신 이메일 랜더
  const RenderEmailInput = () => {
    let renderInput = [];
    for (let i = 0; i < emailCount; i++) {
      renderInput.push(
        <div className="d-flex flex-row mb-1" key={i}>
          <input
            type="email"
            className="form-control mr-2"
            disabled={i === 0}
            value={bookingEmail[i]}
            placeholder={t("schedule.lcl.bookingModal.enterEmail")}
            onChange={(e) => {
              bookingEmail[i] = e.target.value;
            }}
          />
          <div>
            {i > 0 ? (
              <button
                className={"btn btn-danger h-100"}
                style={{ width: 50 }}
                onClick={() => {
                  emailCountDown(i);
                }}
              >
                -
              </button>
            ) : (
              <button
                className={"btn btn-info h-100"}
                style={{ width: 50 }}
                onClick={() => emailCountUp()}
              >
                +
              </button>
            )}
          </div>
        </div>
      );
    }
    return renderInput;
  };

  return (
    <div className="modal_background">
      <input style={{ display: "none" }} aria-hidden="true" />
      <input type="password" style={{ display: "none" }} aria-hidden="true" />
      <div className="modal_body bg-white rounded">
        <div className="p-3 border-bottom d-flex flex-row justify-content-between align-items-center">
          <p className="h5 mr-3 p-0 m-0">
            {t("schedule.lcl.bookingModal.title")}
          </p>
          <div
            className="btn btn-sm btn-danger"
            onClick={() => handleBookingModal(false)}
          >
            <i className="fa-solid fa-xmark" />
          </div>
        </div>

        <div
          className="overflow_scroll-Y p-3 px-4"
          style={{
            maxHeight: "calc(100vh - 200px)",
            minWidth: 320,
            maxWidth: 1000,
          }}
        >
          <div className="mb-3">
            <p className="h6 mb-3">
              ■ {t("schedule.lcl.bookingModal.reservationPerson")} : [
              {loginInfo.comp_nm}] {loginInfo.user_nm}{" "}
              {loginInfo.user_tel ? `(${loginInfo.user_tel})` : ""}
            </p>
            <p className="font-weight-bold">
              {t("schedule.lcl.bookingModal.reservationScheduleInfo")}
            </p>
            <div className="d-flex flex-column flex-xl-row flex-wrap border rounded-top-left rounded-top-right overflow-hidden">
              <div className="border-right flex-grow-1 d-flex flex-column">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {modal_data.sm_FCL_LCL === "LCL"
                    ? t("schedule.consolidator")
                    : t("schedule.carrier")}
                </div>
                <div
                  className="d-flex flex-row justify-content-center align-items-center"
                  style={{ height: 54 }}
                >
                  {modal_data.COMP_LOGO ? (
                    <div
                      style={{
                        backgroundImage: `url('${
                          modal_data.COMP_LOGO.split("?")[0]
                        }')`,
                        backgroundPosition: "50% 50%",
                        backgroundSize: "contain",
                        backgroundRepeat: "no-repeat",

                        width: "50px",
                        height: "50px",
                      }}
                    />
                  ) : (
                    <LogoSvg width={"60px"} />
                  )}
                </div>
              </div>
              <div className="border-right flex-grow-1 d-flex flex-column">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {t("schedule.scheduleNo")}
                </div>
                <div className="p-2 text-center">{modal_data.sm_UID}</div>
              </div>
              <div className="border-right flex-grow-1 d-flex flex-column">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  FCL/LCL
                </div>
                <div className="p-2 text-center">{modal_data.sm_FCL_LCL}</div>
              </div>
              <div className="border-right flex-grow-1 d-flex flex-column">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {modal_data.sm_FCL_LCL === "AIR" ? "FLIGHT" : "VESSEL/VOY"}
                </div>
                <div className="p-2 text-center">
                  <p>{modal_data.sm_VESSEL}</p>
                  <p>{modal_data.sm_VOY}</p>
                </div>
              </div>
              <div className="flex-grow-1 d-flex flex-column flex-xl-row flex-wrap">
                <div className="border-right flex-grow-1 d-flex flex-column">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    POL
                  </div>
                  <div className="p-2 text-center">
                    <p className="font-weight-bold">{modal_data.sm_POL_NAME}</p>
                    <p className="text-danger">
                      {modal_data.sm_DEPARTURE_DATE}
                    </p>
                  </div>
                </div>
                <div className="flex-grow-1">
                  <div
                    className="py-1 px-2 bg-info text-white text-center border-bottom"
                    style={{ minWidth: 100 }}
                  >
                    POD
                  </div>
                  <div className="p-2 text-center">
                    <p className="font-weight-bold">{modal_data.sm_POD_NAME}</p>
                    <p className="text-danger">{modal_data.sm_ARRIVE_DATE}</p>
                  </div>
                </div>
              </div>
            </div>

            <p className="font-weight-bold mt-3">
              {t("schedule.lcl.bookingModal.itemInfo")}
            </p>
            <div style={{ fontSize: "0.9em" }}>
              - {t("schedule.lcl.bookingModal.itemInfoNotice")}
              <div className="d-inline-flex flex-row align-items-center">
                <span
                  style={{ width: 50, height: 18 }}
                  className="d-inline-block bg-info-light mx-2"
                />
                {t("schedule.lcl.bookingModal.inputType")}
              </div>
            </div>
            <div className="row border rounded overflow-hidden my-2 p-0 mx-0">
              <div className="border-right col-12 col-xl-2 m-0 p-0">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {t("schedule.lcl.bookingModal.shipperName")}
                </div>{" "}
                <div className="p-2">
                  <input
                    className="border-0 bg-info-light w-100"
                    type="text"
                    ref={$controller.p_comp_nm}
                    placeholder={t(
                      "schedule.lcl.bookingModal.shipperNameNotice"
                    )}
                  />
                </div>
              </div>
              <div className="border-right col-12 col-xl-2 m-0 p-0">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  H B/L NO
                </div>{" "}
                <div className="p-2">
                  <input
                    className="border-0 bg-info-light w-100"
                    type="text"
                    ref={$controller.p_user}
                    placeholder={t("schedule.lcl.bookingModal.blNotice")}
                  />
                </div>
              </div>
              <div className="border-right col-12 col-xl-2 m-0 p-0">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {t("schedule.lcl.bookingModal.itemName")}
                </div>
                <div className="p-2">
                  <input
                    className="border-0 bg-info-light w-100"
                    type="text"
                    ref={$controller.p_name}
                    placeholder={t("schedule.lcl.bookingModal.itemNameNotice")}
                  />
                </div>
              </div>
              <div className="border-right col-12 col-xl-2 m-0 p-0">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {t("schedule.lcl.bookingModal.weight")}(KG)
                </div>{" "}
                <div className="p-2">
                  <input
                    className="border-0 bg-info-light w-100"
                    type="text"
                    ref={$controller.p_weight}
                    placeholder={t("schedule.lcl.bookingModal.weightNotice")}
                  />
                </div>
              </div>
              <div className="border-right col-12 col-xl-2 m-0 p-0">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {t("schedule.lcl.bookingModal.count")}
                </div>{" "}
                <div className="p-2">
                  <input
                    className="border-0 bg-info-light w-100"
                    type="text"
                    ref={$controller.p_cnt}
                    placeholder={t("schedule.lcl.bookingModal.countNotice")}
                  />
                </div>
              </div>
              <div className="col-12 col-xl-2 m-0 p-0">
                <div
                  className="py-1 px-2 bg-info text-white text-center border-bottom"
                  style={{ minWidth: 100 }}
                >
                  {t("schedule.lcl.bookingModal.cntType")}
                </div>{" "}
                <div className="p-2">
                  <select
                    className="border-0 w-100 bg-info-light"
                    ref={$controller.p_quantities}
                  >
                    {modal_data.sm_FCL_LCL === "AIR" ? (
                      <option value="KG">KG</option>
                    ) : (
                      <>
                        <option value="">
                          {t("schedule.lcl.bookingModal.notSelected")}
                        </option>
                        <option value="CBM">CBM</option>
                        {/*(LCL)*/}
                        <option value="TEU">TEU</option>
                        {/*(20FT)*/}
                        <option value="FEU">FEU</option>
                        {/*(40FT)*/}
                      </>
                    )}
                  </select>
                </div>
              </div>
            </div>
            <UploadImageToS3WithPhp
              region={"mall/booking"}
              callback={(val) => {
                handleUploadFile(val);
              }}
            />
            <div>
              {uploadFile.length > 0 &&
                uploadFile.map((item, index) => {
                  let fileName = item.split("?")[0];
                  let fileLink = item.split("?")[1];
                  return (
                    <p
                      className="d-flex flex-row justify-content-between mb-1 align-items-center"
                      key={index}
                    >
                      <a
                        className="font-weight-bold text-primary"
                        href={fileLink}
                        target="_blank"
                      >
                        {fileName}
                      </a>
                      <button
                        className="btn btn-outline-info"
                        onClick={() => {
                          handleDeleteUploadFile(index);
                        }}
                      >
                        {t("schedule.lcl.bookingModal.delete")}
                      </button>
                    </p>
                  );
                })}
            </div>
          </div>
          <div className="row mb-3">
            <p className="col-12 h6 mb-2">
              ■ {t("schedule.lcl.bookingModal.reservationMemo")}
            </p>
            <div className="col-12">
              <textarea
                className=" form-control"
                ref={$controller.p_memo}
                rows={5}
                placeholder={
                  modal_data.sm_FCL_LCL === "AIR"
                    ? t("schedule.lcl.bookingModal.reservationMemoNoticeAir")
                    : t("schedule.lcl.bookingModal.reservationMemoNoticeSea")
                }
              />
            </div>
          </div>
          <div>
            <p className="h6 mb-2">
              ■ {t("schedule.lcl.bookingModal.reservationInfoReplyEmail")}
            </p>
            <div className="mb-3 row">
              <label className="col-form-label col-sm-3 text-end">
                {t("schedule.lcl.bookingModal.email")}{" "}
              </label>
              <div className="col-sm-9 ">{RenderEmailInput()}</div>
            </div>
          </div>
        </div>

        <div className="p-3 d-flex flex-row justify-content-end align-items-center border-top">
          <div
            className="btn btn-sm btn-danger mr-1 font-size-09"
            style={{ lineHeight: 1.3 }}
            onClick={() => handleBookingModal(false)}
          >
            {t("schedule.lcl.bookingModal.cancel")}
          </div>
          <div
            className="btn btn-sm btn-info ml-1 font-size-09"
            style={{ lineHeight: 1.3 }}
            onClick={() => submit()}
          >
            {t("schedule.lcl.bookingModal.submit")}
          </div>
        </div>
      </div>
    </div>
  );
};
